import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 28 28"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M14.004 2.5c6.351 0 11.5 5.149 11.5 11.5s-5.149 11.5-11.5 11.5c-1.921 0-3.775-.472-5.43-1.36L4.07 25.493a1.25 1.25 0 0 1-1.556-1.557l1.353-4.503A11.451 11.451 0 0 1 2.504 14c0-6.351 5.149-11.5 11.5-11.5zm0 1.5c-5.523 0-10 4.477-10 10 0 1.77.46 3.472 1.322 4.973l.16.28-1.403 4.67 4.672-1.403.28.16c1.5.86 3.2 1.32 4.969 1.32 5.523 0 10-4.477 10-10s-4.477-10-10-10zm-3.75 11.5h4.498a.75.75 0 0 1 .102 1.493l-.102.007h-4.498a.75.75 0 0 1-.102-1.493l.102-.007h4.498-4.498zm0-4.5h7.504a.75.75 0 0 1 .102 1.493l-.102.007h-7.504a.75.75 0 0 1-.102-1.493l.102-.007h7.504-7.504z"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }